import { css as t } from "@microsoft/fast-element";
import { normalize as i } from "../common/normalize.js";
import { display as l } from "@matrix42/fast-foundation";
import { slotStyleSheetBehavior as n } from "../common/behaviors/slot-style-sheet-behavior.js";
import { designTokens as o } from "../design-tokens.js";
import { typography as c } from "../styles/typography.js";
const a = t`
  :host {
    /* Layout */
    gap: 0;
  }
`, $ = (e) => t`
    ${i}
    ${l("inline-flex")}
    :host {
      /* Base */
      outline: none;
      user-select: none;
      /* Layout */
      align-items: center;
      gap: ${o.spacing[2]};
    }

    :host(:focus-visible) .control {
      /* Style */
      outline: ${o.borderRadius.sm} solid ${o.color.black};
      /* TODO: Use design tokens */
      outline-offset: ${o.borderWidth.sm};
    }

    :host(:hover) .control,
    :host(.checked) .control,
    :host(.indeterminate) .control {
      /* Style */
      border-color: ${o.color.primary[200]};
      background-color: ${o.color.primary[200]};
    }

    :host(:active) .control {
      /* Style */
      border-color: ${o.color.primary[500]};
      background-color: ${o.color.primary[500]};
    }

    :host(:disabled) .control {
      /* Style */
      border-color: ${o.color.neutral[70]};
      background-color: ${o.color.white};
    }

    :host(:disabled.checked) .control,
    :host(:disabled.indeterminate) .control {
      /* Style */
      background-color: ${o.color.neutral[70]};
    }

    :host(:disabled) .label {
      /* Style */
      color: ${o.color.neutral[70]};
    }

    :host(.checked) slot[name='checked-indicator'] {
      /* Base */
      display: contents;
    }

    :host(.indeterminate) slot[name='checked-indicator'] {
      /* Base */
      display: none;
    }

    :host(.indeterminate) slot[name='indeterminate-indicator'] {
      /* Base */
      display: contents;
    }

    .control {
      /* Layout */
      display: inline-flex;
      width: ${o.spacing[4]};
      height: ${o.spacing[4]};
      align-items: flex-start;
      /* Style */
      border-radius: ${o.spacing["1.5"]};
      border: ${o.borderWidth.xs} solid
        ${o.color.neutral[80]};

      color: ${o.color.white};
    }

    slot[name='checked-indicator'],
    slot[name='indeterminate-indicator'] {
      /* Base */
      display: none;
    }

    .label {
      /* Style */
      color: ${o.color.neutral[500]};
      /* Typography */
      ${c("p", "regular")}
    }

    ${e.prefix}-icon,
    ::slotted(${e.prefix}-icon) {
      /* Layout */
      width: calc(0.833 * ${o.iconSize.xs}) !important;
      height: calc(0.833 * ${o.iconSize.xs}) !important;
      margin: auto;
      /* Style */
      color: inherit;
    }
  `.withBehaviors(
  n(
    (r) => !r.hasContent("content"),
    a
  )
);
export {
  $ as checkboxStyles
};
